import styles from './Footer.module.scss';
import { FaFacebookSquare, FaPhoneAlt, FaEnvelope, FaAngleRight } from "react-icons/fa";
import React, { useRef } from 'react';
// import { RiFileCopyLine } from 'react-icons/ri';
import copy from 'copy-to-clipboard';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Footer = (props) => {

  const handleCopyToClipboard = (text) => {
    copy(text);
    // alert('Skopiowano do schowka: ' + text);

    toast.dismiss();

    toast.success(`Skopiowano do schowka:\n${text}`, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000, // Czas wyświetlania w milisekundach (tutaj 2 sekundy)
    });
  };

  return (
    <footer className={styles.footerSection}>
        <div className={styles.footerContainer}>
          <div className={styles.footerWrapper}>
            <div  className={styles.footerNav}>
              <div className={styles.box}>
                {props.language === 'pl' &&
                  <p className={styles.footerColumn} onClick={() => props.scrollToSection('sesja1')}>
                    Strony internetowe
                  </p> 
                }
                {props.language === 'eng' &&
                  <p className={styles.footerColumn} onClick={() => props.scrollToSection('sesja1')}>
                    Websites
                  </p> 
                }
                <span className={styles.underlineWhite}></span>
              </div>

              <div className={styles.box}>
                {props.language === 'pl' &&
                  <p className={styles.footerColumn} onClick={() => props.scrollToSection('sesja2')}>
                    Aplikacje webowe
                  </p> 
                }
                {props.language === 'eng' &&
                  <p className={styles.footerColumn} onClick={() => props.scrollToSection('sesja2')}>
                    Web applications
                  </p> 
                }
                <span className={styles.underlineWhite}></span>
              </div>

              <div className={styles.box}>
                {props.language === 'pl' &&
                  <p className={styles.footerColumn} onClick={() => props.scrollToSection('sesja3')}>
                    Vulnerability testy
                  </p>
                }
                {props.language === 'eng' &&
                  <p className={styles.footerColumn} onClick={() => props.scrollToSection('sesja3')}>
                    Vulnerability tests
                  </p>
                }
                <span className={styles.underlineWhite}></span>
              </div>
            </div>

            <div  className={styles.footerNav1}>
              <div className={styles.box}>
                <p className={styles.footerColumn} 
                  // onClick={() => props.scrollToSection('sesja4')} 
                  onClick={e => {handleCopyToClipboard('cometweb.kontakt@gmail.com')}}
                  style={{ cursor: 'pointer' }}>
                  <FaEnvelope/> cometweb.kontakt@gmail.com <ToastContainer />
                </p>
                <span className={styles.underlineWhite}></span>
              </div>

              <div className={styles.box}>
                <p className={styles.footerColumn} style={{ cursor: 'pointer' }} onClick={e => {handleCopyToClipboard('+48 690 688 835')}}>
                  <FaPhoneAlt/> +48 690 688 835 <ToastContainer />
                </p> 
                <span className={styles.underlineWhite}></span>
              </div>

              <div className={styles.box}>
                <p className={styles.footerColumn} style={{ cursor: 'pointer' }} onClick={e => {handleCopyToClipboard('+48 515 499 355')}}>
                  <FaPhoneAlt/> +48 515 499 355 <ToastContainer />
                </p> 
                <span className={styles.underlineWhite}></span>
              </div>

              {/* <div className={styles.box}>
                <p className={styles.footerColumn}>
                  <FaFacebookSquare/> fb.com/cometweb
                </p> 
              <span className={styles.underlineWhite}></span>
              </div> */}
            </div>
          </div>
        </div>

        <div className={styles.copyrightFooter}>
          <div className={styles.copyrightDiv}>
            <p>© All rights reserved</p>
            <img className={styles.footerLogo} alt="CometwebLogo" src={`${process.env.PUBLIC_URL}/Cometweb/1transparentdown.png`}></img>
          </div>
        </div>
      </footer>
  );
};

export default Footer;